import { appConfig } from "../config";
import { buildWebSocketUrl } from "./buildWebSocketUrl";
import { DashboardRealtimeClient } from "./dashboardRealtimeClient";

let singletonClient: DashboardRealtimeClient | null = null;

export function getSingletonDashboardRealtimeClient(): DashboardRealtimeClient {
  const url = buildWebSocketUrl(appConfig.websocketPath);

  if (!singletonClient) {
    singletonClient = new DashboardRealtimeClient(
      { url },
      {
        onDestroy: () => {
          singletonClient = null;
        },
      },
    );
    return singletonClient;
  }

  singletonClient.setConfig({ url });
  return singletonClient;
}
